export const mediaKeys = {
  all: ['media'] as const,
  lists: () => [...mediaKeys.all, 'list'] as const,
  list: (filters: { size: number }) => [...mediaKeys.lists(), filters] as const,
  urlMap: () => [...mediaKeys.all, 'url-map'] as const,
};
